<template>
	<div class="chart-wrapper">
		<div id="tv_chart_container" class="chart-box"></div>
	</div>
</template>
<script>
import kLine from '@/common/mobile/kLine.vue'
export default {
	components: {},
	mixins: [kLine],
	data() {
		return {};
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.chart-box {
	padding: 20px;
	width: 100%;
	height: 665px;
}
</style>